import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAttentionPageRequest } from './attentionApi';
import { extractApiError } from '../../utils/errors';

/**
 * Fetches the queue for the filters currently held in the store.
 *
 * Sentinels are dropped rather than forwarded, same as the rest of the app.
 */
export const fetchAttention = createAsyncThunk(
  'attention/fetchAttention',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { start_date, end_date, company, admin_id, reason, page, rowsPerPage } =
        getState().attention.filters;

      const params = { start_date, end_date, reason, page, page_size: rowsPerPage };
      if (company && company !== 'all') params.company = company;
      // The endpoint reads it only for staff; for anybody else it is ignored on
      // the other side, so it is left out rather than sent to be dropped.
      if (admin_id && admin_id !== 'all') params.admin_id = admin_id;

      const response = await getAttentionPageRequest(params);
      return response.data;
    } catch (error) {
      console.error('Error fetching attention queue:', error);
      return rejectWithValue(
        extractApiError(error, 'No se pudieron obtener los envíos que necesitan atención')
      );
    }
  }
);
